import type { WidgetType } from "legacy/constants/WidgetConstants";

export enum ItemKinds {
  WIDGET = "WIDGET",
  NESTED_ITEM = "NESTED_ITEM",
  API_V1 = "API_V1",
  API_V2 = "API_V2",
  EMBED_PROP = "EMBED_PROP",
  ROUTE = "ROUTE",
  AI_EDIT = "AI_EDIT",
  AI_EDITS_HISTORY = "AI_EDITS_HISTORY",
}

export type ItemWithPropertiesType = WidgetType | ItemTypeNonWidget;

export enum ItemTypeNonWidget {
  NESTED_ITEM = ItemKinds.NESTED_ITEM,
  API_V1 = ItemKinds.API_V1,
  API_V2 = ItemKinds.API_V2,
  EMBED_PROP = ItemKinds.EMBED_PROP,
  ROUTE = ItemKinds.ROUTE,
  AI_EDIT = ItemKinds.AI_EDIT,
  AI_EDITS_HISTORY = ItemKinds.AI_EDITS_HISTORY,
}
